import { ExternalRedirect } from 'src/components/ExternalRedirect';

export const FinanceRoutes = [
  {
    path: '/promocoes',
    exact: true,
    isPrivate: true,
    component: (
      <ExternalRedirect
        to={`${process.env.REACT_APP_VENDORS_PORTAL_API_URL}/promocoes`}
      />
    ),
  },
  {
    path: '/extrato',
    exact: true,
    isPrivate: true,
    component: (
      <ExternalRedirect
        to={`${process.env.REACT_APP_VENDORS_PORTAL_API_URL}/extrato`}
      />
    ),
  },
];
